export { default as personaValidator } from './PersonaValidator';


// WEBPACK FOOTER //
// ./client/services/validators/index.js